import * as appStore from 'app/store/appStore';
import { WidgetActionType } from 'widgets/store/actions';
import { ActionSanitizer } from 'store/devToolsActionSantizer';
import { AnyAction } from 'redux';
import {
    recordMessage,
    recordStatus,
} from 'app/glue/bloomberg/store/bloombergSlice';
import { addBar, addBars } from 'marketData/store/marketDataSlice';

export const actionsBlacklist: string[] = [
    WidgetActionType.WIDGET_RECEIVE_STREAM_MESSAGE,
    recordMessage.type,
    recordStatus.type,
    addBars.type,
    addBar.type,
];

export const removeIgnoredActions: (actions: AnyAction[]) => AnyAction[] = (
    actions
) => actions.filter((a) => actionsBlacklist.indexOf(a.type) === -1);

export const actionSanitizers = [...appStore.DevToolsActionSanitizers];

export const actionSanitizer: ActionSanitizer = (action, id) => {
    let ret = action;
    for (const san of actionSanitizers) {
        ret = san(action, id);
    }
    return ret;
};
